import { AxiosInstance } from 'axios';
import { TlnkOptionsRepository } from '~/model/repository/manager/tlnk/TlnkOptionsRepository';

export default (Repository: AxiosInstance) => (): TlnkOptionsRepository => ({
  get() {
    return Repository.get(`/memories-api/v1/admin/tlnk-account-linkage`);
  },
});
